import axiosServices from "../utils/axios"

interface FetchApiResponceResponse {
    data: any[]
}

export const fetchNotificationsList= async()=>{
    const response = await axiosServices.get<FetchApiResponceResponse>("/notificationlist")
    return response.data;
}